import { pathWithRegion } from './navBase';

export const CATEGORIES_TYPES = ['movies', 'tv', 'anime', 'anime-movies', 'anime-tv'];

/** URL segment is a valid genre slug (admin-managed); not a reserved category type. */
export function normalizeGenreSlug(param) {
  const s = String(param || '').toLowerCase().trim();
  if (!s) return null;
  if (CATEGORIES_TYPES.includes(s)) return null;
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(s)) return null;
  return s;
}

export function categoriesHubPath(region) {
  return pathWithRegion('/categories', region);
}

export function categoriesTypePath(type, region) {
  return pathWithRegion(`/categories/${type}`, region);
}

/** Dedicated Similar pages: /similar/movies, /similar/tv, /similar/anime */
export function similarTypePath(type, region) {
  return pathWithRegion(`/similar/${type}`, region);
}

/** Genre browse: /categories/action, /categories/sci-fi, etc. */
export function categoriesGenrePath(genreSlug, region) {
  return pathWithRegion(`/categories/${genreSlug}`, region);
}

export function normalizeCategoryType(param) {
  const t = String(param || '').toLowerCase();
  return CATEGORIES_TYPES.includes(t) ? t : null;
}
